import { render, staticRenderFns } from "./RowBlockWithdrawalOfFunds.vue?vue&type=template&id=ff731c26&"
import script from "./RowBlockWithdrawalOfFunds.vue?vue&type=script&lang=js&"
export * from "./RowBlockWithdrawalOfFunds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports